<template>
  <div>
    <label for="ef">{{ titulo }}</label>
    <b-skeleton-wrapper :loading="entidadesLoader">
      <template #loading>
        <b-skeleton
          type="button"
          width="100%"
          class="mb-75"
        />
      </template>
      <div class="mb-75">
        <v-select
          id="ef"
          placeholder="Seleccione entidad federativa"
          label="nombre"
          :value="ef"
          :options="estados"
          :clearable="clear"
          @input="(val) => $emit('selectef', val)"
        />
      </div>
    </b-skeleton-wrapper>
  </div>
</template>
<script>
import {
  BSkeletonWrapper,
  BSkeleton,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { ref } from '@vue/composition-api'
import { getData } from '@core/utils/http/general'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    vSelect,
    BSkeletonWrapper,
    BSkeleton,
  },
  props: {
    ef: {
      type: [Object, null],
      default: null,
    },
    titulo: {
      type: [String, null],
      default: 'Entidad Federativa',
    },
    clear: {
      type: [Boolean, null],
      default: false,
    },
  },
  setup() {
    const estados = ref([])
    const toast = useToast()
    const entidadesLoader = ref(false)
    const loadEntidades = () => {
      entidadesLoader.value = true
      getData({ action: 2 }, 'wspublico')
        .then(response => {
          entidadesLoader.value = false
          if (response.status === 200) {
            estados.value = response.data.data || []
          } else {
            toast({
              component: ToastificationContent,
              props: {
                title: 'Error cargando entidades federativas',
                text: response.data.message,
                icon: 'AlertCircleIcon',
                variant: 'danger',
              },
            },
            { timeout: 10000 })
          }
        }, error => {
          entidadesLoader.value = false
          toast({
            component: ToastificationContent,
            props: {
              title: 'Error cargando entidades federativas',
              text: error,
              icon: 'AlertCircleIcon',
              variant: 'danger',
            },
          },
          { timeout: 10000 })
        })
    }
    loadEntidades()
    return {
      estados,
      entidadesLoader,
    }
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
